import _regeneratorRuntime from "babel-runtime/regenerator";
import _Promise from "babel-runtime/core-js/promise";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import sysConfig from "../../config/sysConfig";
import store from "../../vuex";
import types from "@/vuex/mutation-types";
import { JSEncrypt } from "jsencrypt";

window.publicKey = "";
var fxcEncrypt = {
  getPublicKey: function getPublicKey() {
    var _this = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!window.publicKey) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", window.publicKey);

            case 2:
              store.commit(types.$types.UPDATE_LOADING, "获取数据中");
              _context.next = 5;
              return sysConfig.$syscfg.K_Request("F0000007");

            case 5:
              res = _context.sent;

              if (!(res.Code == 0)) {
                _context.next = 12;
                break;
              }

              window.publicKey = res.Data[0].publickey || "";
              store.commit(types.$types.UPDATE_LOADING, false);
              return _context.abrupt("return", _Promise.resolve(true));

            case 12:
              consoleLog("publicKey获取失败", res);
              _this.alert("参数获取失败" + res.Msg);
              return _context.abrupt("return", _Promise.resolve(false));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  encrypt: function encrypt(val) {
    var _this2 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
      var encrypt, password;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this2.getPublicKey();

            case 3:
              encrypt = new JSEncrypt();

              encrypt.setPublicKey(window.publicKey);
              password = encrypt.encrypt(val);
              return _context2.abrupt("return", password);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);

              consoleError("加密失败", _context2.t0);
              alert("加密失败");
              return _context2.abrupt("return", false);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 9]]);
    }))();
  }
};

export default fxcEncrypt;


//////////////////
// WEBPACK FOOTER
// ./src/tools/libs/fxcEncrypt.js
// module id = 998
// module chunks = 2